import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.community
)

export const selectCommunityInfo = createSelector(
    baseSelector,
    (state) => state.community
)

export const selectCommunityLoading = createSelector(
    baseSelector,
    (state) => state.isLoading
)

export const selectCommunityError = createSelector(
    baseSelector,
    (state) => state.error
)

export const selectMasterWallet = createSelector(
    baseSelector,
    (state) => state.masterWallet
)

export const selectMainWallet = createSelector(
    baseSelector,
    (state) => state.wallet
)